// 将中文、英语、日语、韩语排在最前，剩余语言按首字母排序
import { OptionItem } from '@com/type/common.type'

// 新增多国家语言排在最前面 'v1'-26, 'v2'-57, 'v3'-77
const commonLanguages = ['v3', 'v2', 'v1', 'zh-cn', 'en', 'ja', 'ko']

// V3,v1 包含全部国家展示
export const unlimitedLanguageTip = {
  v3: '南非荷兰语、阿尔巴尼亚语、阿姆哈拉语、阿拉伯语、亚美尼亚语、阿塞拜疆语、印度尼西亚语、孟加拉语、巴斯克语、孟加拉语、波斯尼亚语、保加利亚语、缅甸语、加泰罗尼亚语、粤语、普通话、中国台湾话、克罗地亚语、捷克语、丹麦语、荷兰语、英语、爱沙尼亚语、菲律宾语、芬兰语、法语、加利西亚语、格鲁吉亚语、德语、希腊语、希伯来语、印度语、匈牙利语、冰岛语、爱尔兰语、意大利语、日语、爪哇语、卡纳达语、哈萨克语、高棉语、韩语、老挝语、拉脱维亚语、立陶宛语、马其顿语、马来语、马拉雅拉姆语、马耳他语、蒙古语、尼泊尔语、挪威博克马尔语、普什图语、波斯语、波兰语、葡萄牙语、罗马尼亚语、俄语、塞尔维亚语、僧伽罗语、斯洛伐克语、斯洛文尼亚语、索马里语、西班牙语、巽他语、斯瓦希里语、瑞典语、泰米尔语、泰卢固语、泰语、土耳其语、乌克兰语、乌尔都语、乌兹别克语、越南语、威尔士语、祖鲁语',
  v1: '阿拉伯语、加泰罗尼亚语、粤语、普通话、中国台湾话、捷克语、丹麦语、荷兰语、英语、芬兰语、法语、德语、印度语、匈牙利语、印度尼西亚语、意大利语、日语、韩语、挪威博克马尔语、波兰语、葡萄牙语、俄语、西班牙语、瑞典语、泰语、土耳其语',
}

export function getCommonLanguages(
  languageList: OptionItem[],
  commonLang?: OptionItem['value'][], // 自定义常用语言
) {
  const commonLanguageCode =
    commonLang && commonLang.length ? commonLang : commonLanguages

  return languageList
    .filter((item: OptionItem) => {
      return commonLanguageCode.includes(item.value)
    })
    .sort((a: OptionItem, b: OptionItem) => {
      return (
        commonLanguageCode.indexOf(a.value) -
        commonLanguageCode.indexOf(b.value)
      )
    })
}

export function getOtherLanguages(
  languageList: OptionItem[],
  commonLang?: OptionItem['value'][], // 自定义常用语言
) {
  const commonLanguageCode =
    commonLang && commonLang.length ? commonLang : commonLanguages

  return languageList
    .filter((item: OptionItem) => {
      return !commonLanguageCode.includes(item.value)
    })
    .sort((a: OptionItem, b: OptionItem) => {
      return a.label.localeCompare(b.label)
    })
}
